import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PricingPlans } from './pricing-plans';
import { useState } from 'react';

interface InsufficientCreditsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function InsufficientCreditsModal({
  isOpen,
  onClose,
}: InsufficientCreditsModalProps) {
  const [activeTab, setActiveTab] = useState('subscription');
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="border-border max-h-[90vh] overflow-y-auto bg-background sm:max-w-[900px]">
        <DialogHeader className="space-y-2">
          <DialogTitle className="font-semibold text-foreground">
            Purchase Credits or Subscribe
          </DialogTitle>
          <p className="text-muted-foreground text-sm">
            Choose a plan that works best for you
          </p>
        </DialogHeader>
        <div className="duration-200 transition-colors">
          <PricingPlans
            activeTab={activeTab}
            onTabChange={setActiveTab}
            buttonLabel="Select Plan"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
